export default {
    acc: 'https://acc.staging.mrbilit.ir',
    auth: 'https://auth.staging.mrbilit.ir',
    bill: 'https://bill.staging.mrbilit.ir',
    bus: 'https://bus.staging.mrbilit.ir',
    content: 'https://content.mrbilit.ir',
    coupon: 'https://coupon.staging.mrbilit.ir',
    faas: 'https://fn.mrbilit.com',
    finalize: 'https://finalize.staging.mrbilit.ir/api',
    flight: 'https://flight.staging.mrbilit.com',
    giftCard: 'https://giftcard.staging.mrbilit.ir/',
    hotel: 'https://hotel.staging.mrbilit.ir',
    notifier: 'https://notifier.staging.mrbilit.ir',
    panel: 'https://panel.staging.mrbilit.com',
    payment: 'https://payment.staging.mrbilit.com',
    priceTrack: 'https://pricetrack.staging.mrbilit.ir',
    tracking: 'https://errortracking.mrbilit.net',
    train: 'https://train.staging.mrbilit.ir',
    flightInfo: 'https://flightinfo.staging.mrbilit.ir',
    userLog: 'https://user-log.mrbilit.ir',
    workflow: 'https://workflow.staging.mrbilit.ir',
    support: 'https://support.staging.mrbilit.com',
    multiRoute: 'https://masir.staging.mrbilit.com/',
};
